// extracted by mini-css-extract-plugin
module.exports = {"root":"RSClampedText_root__lwLm0"};